import React from 'react';
import Icon from '../../../components/AppIcon';

const FormValidationSummary = ({ errors, completedFields, totalFields }) => {
  const errorCount = Object.keys(errors)?.length;
  const completionPercentage = Math.round((completedFields / totalFields) * 100);
  const hasErrors = errorCount > 0;

  if (completedFields === totalFields && !hasErrors) {
    return (
      <div className="bg-success/10 border border-success/20 rounded-lg p-4 mb-6">
        <div className="flex items-center">
          <Icon name="CheckCircle" size={20} className="text-success ml-3" />
          <div>
            <h4 className="text-sm font-medium text-success">
              پروفایل آماده تکمیل است
            </h4>
            <p className="text-xs text-success/80 mt-1">
              تمام فیلدهای ضروری تکمیل شده‌اند
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`border rounded-lg p-4 mb-6 ${
      hasErrors 
        ? 'bg-destructive/5 border-destructive/20' :'bg-muted/50 border-border'
    }`}>
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center">
          <Icon 
            name={hasErrors ? "AlertTriangle" : "Info"} 
            size={20} 
            className={`ml-3 ${hasErrors ? 'text-destructive' : 'text-muted-foreground'}`} 
          />
          <h4 className={`text-sm font-medium ${
            hasErrors ? 'text-destructive' : 'text-foreground'
          }`}>
            وضعیت تکمیل پروفایل
          </h4>
        </div>
        <span className={`text-xs px-2 py-1 rounded-full ${
          completionPercentage === 100 
            ? 'bg-success/20 text-success' 
            : completionPercentage >= 75
              ? 'bg-warning/20 text-warning' :'bg-muted text-muted-foreground'
        }`}>
          {completionPercentage}%
        </span>
      </div>
      {/* Progress Details */}
      <div className="space-y-2">
        <div className="flex justify-between text-xs text-muted-foreground">
          <span>فیلدهای تکمیل شده: {completedFields} از {totalFields}</span>
          {hasErrors && (
            <span className="text-destructive">
              {errorCount} خطا وجود دارد
            </span>
          )}
        </div>

        {/* Progress Bar */}
        <div className="w-full bg-muted rounded-full h-2">
          <div 
            className={`h-2 rounded-full transition-all duration-300 ${
              completionPercentage === 100 
                ? 'bg-success' 
                : completionPercentage >= 75
                  ? 'bg-warning' :'bg-primary'
            }`}
            style={{ width: `${completionPercentage}%` }}
          />
        </div>
      </div>
      {/* Error List */}
      {hasErrors && (
        <div className="mt-3 pt-3 border-t border-destructive/20">
          <p className="text-xs text-destructive mb-2">
            لطفاً موارد زیر را تصحیح کنید:
          </p>
          <ul className="space-y-1">
            {Object.entries(errors)?.map(([field, error]) => (
              <li key={field} className="flex items-center text-xs text-destructive">
                <Icon name="AlertCircle" size={12} className="ml-2 flex-shrink-0" />
                {error}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default FormValidationSummary;